export const PERMISSIONS = {
  'project.create': ['admin', 'owner'],
  'project.archive': ['admin', 'owner'],
  'project.delete': ['admin', 'owner'],
  'pipeline.run': ['admin', 'owner'],
  'masterPrompt.approve': ['admin', 'owner'],
  'masterPrompt.renormalize': ['admin', 'owner'],
  'scoutProfile.create': ['admin', 'owner'],
  'scoutProfile.update': ['admin', 'owner'],
  'scoutProfile.delete': ['admin', 'owner'],
  'scoutProfile.run': ['admin', 'owner'],
  'product.create': ['admin', 'owner'],
  'product.update': ['admin', 'owner'],
  'product.delete': ['admin', 'owner'],
  'review.decide': ['expert', 'admin', 'owner'],
  'task.create': ['admin', 'owner', 'controller'],
  'task.approveReject': ['admin', 'owner', 'controller'],
  'dashboard.viewOwnerSummary': ['admin', 'owner', 'controller'],
  'dashboard.viewExpertSummary': ['expert', 'admin', 'owner', 'controller'],
  'dashboard.viewManagerSummary': ['manager', 'admin', 'owner', 'controller'],
  'dashboard.viewViewerSummary': ['admin', 'owner', 'controller', 'manager', 'expert', 'viewer'],
  'organization.view': ['admin', 'owner', 'controller', 'manager', 'expert', 'viewer'],
  'organization.manage': ['admin', 'owner'],
  'agent.write': ['admin', 'owner'],
  'claim.promote': ['admin', 'owner', 'expert'],
  'method.attach': ['admin', 'owner', 'expert'],
  'equipment.capability.attach': ['admin', 'owner', 'expert'],
  'label.claim.create': ['admin', 'owner'],
  'product.claim.create': ['admin', 'owner', 'expert'],
  'marketing.claim.create': ['admin', 'owner', 'expert'],
  'claim.attach_fact': ['admin', 'owner', 'expert'],
  'test_plan.create': ['admin', 'owner', 'expert'],
  'experiment_design.create': ['admin', 'owner', 'expert'],
  'experiment_run.create': ['admin', 'owner', 'expert'],
  'document_template.create': ['admin', 'owner', 'expert'],
  'generated_document.create': ['admin', 'owner', 'expert'],
  'approved_document.create': ['admin', 'owner'],
  'geological_unit.create': ['admin', 'owner', 'expert'],
  'ore_body.create': ['admin', 'owner', 'expert'],
  'reserve_estimate.create': ['admin', 'owner', 'expert'],
  'material_sample.create': ['admin', 'owner', 'expert'],
  'sampling_event.create': ['admin', 'owner', 'expert'],
  'property_type.create': ['admin', 'owner'],
  'material_property.create': ['admin', 'owner', 'expert'],
  'material_property.validate': ['admin', 'owner', 'expert'],
  'product_family.create': ['admin', 'owner'],
  'product_type.create': ['admin', 'owner'],
  'product_variant.create': ['admin', 'owner', 'expert'],
  // D-EQUIP-TAXONOMY (PQ-4): equipment axis dictionary + taxonomy = curator; values = expert+
  'equipment_capability_type.create': ['admin', 'owner'],
  'equipment_type.taxonomy.create': ['admin', 'owner'],
  'equipment_capability.create': ['admin', 'owner', 'expert'],
  'resource_site.manage': ['admin', 'owner', 'expert'],
  // D-REGULATORY (F-ENTRY-REGULATORY)
  'regulatory_regime.manage':  ['admin', 'owner'],
  'test_requirement.manage':   ['admin', 'owner'],
  'legal_act.manage':          ['admin', 'owner', 'expert'],
  'attestation.manage':        ['admin', 'owner', 'expert'],
  'org_accreditation.manage':  ['admin', 'owner', 'expert'],
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;

export function canUserPerform(userRole: string | undefined, key: PermissionKey): boolean {
  if (!userRole) return false;
  const allowed = PERMISSIONS[key] as readonly string[] | undefined;
  if (!allowed) return false;
  return allowed.includes(userRole);
}
